import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('dugez_admin_token'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await axios.post(
            `${API}/auth/verify`,
            {},
            {
              headers: { Authorization: `Bearer ${token}` }
            }
          );
          setIsAuthenticated(response.data.valid);
        } catch (error) {
          setIsAuthenticated(false);
          localStorage.removeItem('dugez_admin_token');
          setToken(null);
        }
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false);
    };

    verifyToken();
  }, [token]);

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, {
        username,
        password
      });
      const { token: newToken } = response.data;
      localStorage.setItem('dugez_admin_token', newToken);
      setToken(newToken);
      setIsAuthenticated(true);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.detail || 'Errore durante il login'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('dugez_admin_token');
    setToken(null);
    setIsAuthenticated(false);
  };

  const getAuthHeader = () => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        loading,
        login,
        logout,
        getAuthHeader,
        token
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};